import type { Ref, TableHTMLAttributes } from "react";

import { table } from "~/components/Table.css";

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  ref?: Ref<HTMLTableElement>;
}

/**
 * Themed <table> wrapper. Callers write plain thead/tbody/th/td
 * children — descendant selectors in the token layer style every
 * cell. Keep the API minimal: this is not a data-table abstraction.
 */
export function Table({ className, ref, ...rest }: TableProps) {
  const merged =
    className !== undefined && className.length > 0
      ? `${table} ${className}`
      : table;
  return <table ref={ref} className={merged} {...rest} />;
}
